import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function AssignmentLoadingState() {
  return (
    <div className='space-y-4'>
      {[1, 2, 3, 4, 5].map(i => (
        <Card key={i}>
          <CardHeader className='pb-3'>
            <div className='flex items-start justify-between'>
              <div className='flex-1 space-y-2'>
                <div className='flex items-center gap-2'>
                  <Skeleton className='h-4 w-4' />
                  <Skeleton className='h-4 w-20' />
                  <Skeleton className='h-4 w-16' />
                </div>
                <Skeleton className='h-5 w-3/4' />
                <Skeleton className='h-4 w-1/2' />
              </div>
              <Skeleton className='h-8 w-24' />
            </div>
          </CardHeader>
          <CardContent>
            <Skeleton className='h-2 w-full mb-4' />
            <div className='flex gap-2'>
              <Skeleton className='h-8 w-24' />
              <Skeleton className='h-8 w-24' />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
